import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Button, Grid, Typography, FormControl, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';

import {
    actionGetOrderLocationsByDisplayArea, actionShopcartResetOrderProducts,
    actionResetPaymentTransaction
} from 'actions'

import { actionStartAppLoader, actionEndAppLoader } from 'actions/actionAppLoader';
import ErrorHandling from 'components/ErrorHandling/ErrorHandling';

const { OrderLocationPageTabTitle } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            marginTop: theme.spacing(5)
        }
    },
    radioGroup: {
        display: "flex !important"
    }
}));

const OrderLocationTab = (props) => {

    const classes = useStyles();
    const dispatch = useDispatch();
    const [errorMsg, seterrorMsg] = useState("");
    let [orderLocation, setOrderLocation] = useState(null);
    let [tabLocation, setTabLocation] = useState(0);

    const payment = useSelector(state => state.reducerPaymentTransaction.Payment);
    const orderLocationsLoading = useSelector(state => state.reducerOrderLocations.loading);
    const orderLocations = useSelector(state => state.reducerOrderLocations.orderLocations);
    const orderLocationOrignal = useSelector(state => state.reducerOrderLocations.orderLocation);

    useEffect(() => {
        if (props.match.path == "/orderlocationtab/:name") {
            if (orderLocations == undefined || orderLocations.length == 0)
                actionGetOrderLocationsByDisplayArea(dispatch, 0);
        }
        else {
            props.history.push('/notfound');
        }
    }, [])

    useEffect(() => {
        if (orderLocations && orderLocations.length > 0) {
            var orderLocation = orderLocations.find(x => x.OrderLocation == props.match.params.name);

            setOrderLocation(orderLocation)
            if (orderLocationOrignal && orderLocationOrignal.OrderLocation != orderLocation.OrderLocation) {
                actionShopcartResetOrderProducts(dispatch);
            }

            if (orderLocation && orderLocation.TabLocations && orderLocation.TabLocations.length == 1) {
                props.history.push('/ordermenu/' + orderLocation.TabLocations[0].TabLocationID);
            }
        }
    }, [orderLocations])

    useEffect(() => {
        if (orderLocationsLoading) {
            actionStartAppLoader(dispatch);
        }
        else {
            actionEndAppLoader(dispatch);
        }
    }, [orderLocationsLoading])


    const errorcancelhandle = () => {
        seterrorMsg("");
    }

    const onClickBrowserMenuHandler = () => {
        let tabLocationID = orderLocation.TabLocations.find(x => x.TabLocationName == tabLocation).TabLocationID;
        props.history.push('/ordermenu/' + tabLocationID);
    }

    useEffect(() => {
        if (payment && payment.ReceiptNo && payment.ReceiptNo.toString().length > 0) {
            actionResetPaymentTransaction(dispatch);
        }
    }, []);

    if (orderLocation == undefined)
        return null
    else
        return (
            <Grid className={classes.root} container spacing={2} justifyContent="center">
                <ErrorHandling msg={errorMsg} open={errorMsg != ""} handleclose={errorcancelhandle} />
                <Grid item xs={12} align="center">
                    <Typography variant="h1" color="textPrimary" >{orderLocation.OrderLocation}</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormControl component="fieldset" fullWidth={true}>
                        <Typography variant="h4" color="textPrimary" >{OrderLocationPageTabTitle}</Typography>
                        <RadioGroup className={classes.radioGroup} aria-label="TabLocation" name="TabLocation1" value={tabLocation}
                            onChange={(event) => { setTabLocation(event.target.value) }}>
                            {orderLocation.TabLocations.map(tl => {
                                return (<FormControlLabel key={tl.TabLocationID} value={tl.TabLocationName} control={<Radio />} label={tl.TabLocationName} />)
                            })}

                        </RadioGroup>
                    </FormControl>
                </Grid>
                <Grid item xs={12} align="center">
                    <Button className={classes.button} variant='contained' color='primary'
                        onClick={onClickBrowserMenuHandler}
                        disabled={tabLocation == "" ? true : false}>
                        Browse Menu
                    </Button>
                </Grid>
            </Grid>
        );
};

export default OrderLocationTab;
